<template>
  <div>
    <div class="flex items-start gap-20 mb-3 pt-4">
      <div class="flex w-2/5 flex-col items-center px-3">
        <div class="flex-1 flex flex-col md:flex-row pb-4">
          <div class="w-full flex-1 mx-2">
            <div class="my-2 p-1 flex">
              <img :src="album.cover" width="200px" />
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-full py-4">
        <div class="w-1/2">
          <form-item label='Album Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.name }}</p>
            </template>
          </form-item>
          <form-item  label='Artist Name'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.artist }}</p>
            </template>
          </form-item>
          <form-item label='Year'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.year }}</p>
            </template>
          </form-item>
          <form-item label='Language'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.language }}</p>
            </template>
          </form-item>
          <form-item label='Composer'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.composer || '-' }}</p>
            </template>
          </form-item>
        </div>
        <div class="w-1/2">
          <form-item label='Subscription'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.is_subscription == 0 ? 'No' : `Yes` }}</p>
            </template>
          </form-item>
          <form-item label='Sell Song Individually'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.sell_song_individually == 0 ? 'No' : `Yes` }}</p>
            </template>
          </form-item>
          <form-item label='Paid Album'>
            <template v-slot>
              <p class="text-left font-bold">{{ album.is_paid == 0 ? 'Free' : `Paid` }}</p>
            </template>
          </form-item>
          <form-item v-if="album.is_paid == 1" label='Album Price (USD)'>
            <template v-slot>
              <p class="text-left font-bold">$ {{ parseFloat(toDollar(album.price)).toFixed(2) }} &nbsp;&nbsp; = {{ parseFloat(album.price).toFixed(2) }} Credits</p>
            </template>
          </form-item>
          <form-item label='Copyright'>
            <template v-slot>
              <a :href="album.copyright" target="_blank" v-if="!!album.copyright"
                 class="underline w-full inline-block text-left font-bold"
              >Copyright Link</a>
              <p class="text-left font-bold" v-else>-</p>
            </template>
          </form-item>
        </div>
      </div>
    </div>
    <div class="px-2">
      <data-tables :layout="'table'" :data="dataDetailSong" :total="dataDetailSong.length" :pagination-props="{ pageSizes: [100] }">
        <el-table-column v-for="title in titleSong" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
        </el-table-column>
        <el-table-column label="Song" width="250px" >
          <template slot-scope="scope">
            <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
              Audio tag not supported
            </audio>
          </template>
        </el-table-column>
      </data-tables>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import axios from 'axios';
import helpersMixin from '../../mixins/helpers.mixins';
import { FormItem } from '@/components/Layout/Form';

const API_URL = process.env.API_URL;
export default {
  name: 'DetailAlbum',
  mixins: [helpersMixin],
  props: {
    albumId: {
      type: Number,
    },
    toggleReset: {
      type: Boolean,
    },
  },
  data() {
    return {
      dataLanguages: [],
      album: {
        name: '',
        year: '',
        price: '',
        cover: null,
        copyright: null,
        content: [],
        is_paid: 0,
        is_subscription: 0,
        sell_song_individually: 0,
        language: '',
      },
      dataDetailSong: [],
      titleSong: [
        {
          prop: 'title',
          label: 'Title',
        },
        {
          prop: 'year',
          label: 'Year',
        },
        {
          prop: 'genre',
          label: 'Category',
        },
        {
          prop: 'composer',
          label: 'Composer',
        },
        {
          prop: 'cover_type',
          label: 'Type',
        },
        {
          prop: 'original_artist_name',
          label: 'Original Artist',
        },
        {
          prop: 'status',
          label: 'Status',
        },
        {
          prop: 'publish_status',
          label: 'Published',
        },
      ],
    };
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  watch: {
    toggleReset: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getDetailAlbum();
        }
      },
    },
  },
  methods: {
    ...mapActions('AlbumModule', [
      'requestDetailAlbum',
    ]),
    async getDetailAlbum() {
      this.album = await this.requestDetailAlbum(this.albumId);
      const findLang = this.dataLanguages.find(lang => lang.value == this.album.language);
      this.album.language = findLang != undefined ? findLang.label : '-';
      this.dataDetailSong = await Promise.all(this.album.content.map(async (song) => {
        // console.log(song.genres);
        let genres = '';
        if (song.genres.length > 0) {
          genres = this.album.content[0].genres.map(c => {
            return c.name
          }).join(', ');
        }else{
          genres = song.genre;
        }
        let status = '';
        switch (song.status) {
          case 1:
            status = 'Under Review';
            break;
          case 2:
            status = 'Approved';
            break;
          case 3:
            status = 'Rejected';
            break;
          case 4:
            status = 'Published';
            break;
          // eslint-disable-next-line no-fallthrough
          case 0:
          default:
            status = 'Waiting For Review';
            break;
        }
        const file = await this.getMusicFile(song.file);
        return Object.assign(
          {},
          song,
          {
            genre:genres,
            cover_type: song.is_cover === 1 ? 'Cover' : 'Original',
            status,
            statusCode: song.status,
            file,
            publish_status: song.published ? 'Published' : 'Not Published',
            elapsed_day: `${song.elapsed_day} ${song.elapsed_day > 1 ? 'days' : 'day'}`,
          },
        );
      }));
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileAudio.data;
    },
  },
  components: {FormItem}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Album/DetailAlbum.vue